// Encode a raw integer pk into the Relay-style global id used everywhere in
// the app's routing and GraphQL ID args (e.g. `/driver/<gid>`).
export function toGlobalId(typeName, rawId) {
    if (rawId == null) return null
    try {
        return btoa(`${typeName}:${rawId}`)
    } catch (e) {
        return null
    }
}

export function fmtMoney(v) {
    if (v == null || v === '') return '—'
    const n = Number(v)
    if (Number.isNaN(n)) return v
    return `$${n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`
}

export function fmtDate(v) {
    if (!v) return '—'
    return new Date(v).toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

// "Thu, May 28, 2026 9:29 AM"
export function fmtFullDateTime(v) {
    if (!v) return '—'
    return new Date(v).toLocaleString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    })
}

function fmtDateOnly(d) {
    return d.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
}

function fmtClockOnly(d) {
    return d.toLocaleString(undefined, {
        hour: 'numeric',
        minute: '2-digit',
    })
}

// "8:30 PM · 5 hours ago" if < 24h, otherwise "Sep 4, 1986 · 3 days ago"
export function fmtCreatedAt(v, now = new Date()) {
    if (!v) return '—'
    const d = new Date(v)
    const diffMs = now.getTime() - d.getTime()
    const diffHours = diffMs / (1000 * 60 * 60)
    if (diffHours < 24) {
        const hours = Math.max(1, Math.floor(diffHours))
        const suffix = hours === 1 ? '1 hour ago' : `${hours} hours ago`
        return `${fmtClockOnly(d)} · ${suffix}`
    }
    const days = Math.floor(diffHours / 24)
    const suffix = days === 1 ? '1 day ago' : `${days} days ago`
    return `${fmtDateOnly(d)} · ${suffix}`
}

// "May 22, 10:23 AM" plus " · 3 days ago" if older than ~24h.
export function fmtActivityTimestamp(v, now = new Date()) {
    if (!v) return '—'
    const d = new Date(v)
    const datePart = d.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
    const diffMs = now.getTime() - d.getTime()
    const diffHours = diffMs / (1000 * 60 * 60)
    if (diffHours < 24) return datePart
    const days = Math.floor(diffHours / 24)
    const suffix = days === 1 ? '1 day ago' : `${days} days ago`
    return `${datePart} · ${suffix}`
}

const WEEKDAYS_LONG = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export function weekdayLong(n) {
    if (n == null || n < 0 || n > 6) return ''
    return WEEKDAYS_LONG[n]
}
